module.exports = __webpack_public_path__ + "img/navigation-1.730aecab.png";